import { Injectable } from '@angular/core';

// Import's Services:
import { ReportesRequestService } from './request/reportes-request.service';
import { FiltrosRequestService } from './request/filtros-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioSomaService {

  constructor( private requestUrlReporte: ReportesRequestService,
              private requestUrlFiltro: FiltrosRequestService ) { }

  public async getReponse( objetoSoma: SomaServiceEntity ) {
    try {
      const response = await this.requestUrlReporte.getRequest(
        'soma/reporte',
        [ objetoSoma.codigoBaseDatos,
          {
            'ln_unco_sde' : objetoSoma.idSede,
            'ld_fcha_incl' : objetoSoma.fechaInicial,
            'ld_fcha_fnl' : objetoSoma.fechaFinal,
            sma : objetoSoma.sma
          }
        ]
      );

      if (response != null) {
        return response;
      } else {
        return null;
      }

    } catch (exception) {
      console.log(exception);
    }
  }

  public async getResponseFilters( objetoSoma: SomaServiceEntity ) {
    try {
      const response = await this.requestUrlFiltro.getRequest(
        'soma/sedes',
        [ objetoSoma.codigoBaseDatos, { 'ln_unco_lgn' : objetoSoma.idLogin } ]
      );

      if (response != null) {
        return response;
      } else {
        return null;
      }

    } catch (exception) {
      console.log(exception);
    }
  }

}

export interface SomaServiceEntity {
  codigoBaseDatos: string;
  idLogin: string;
  idSede: string;
  fechaInicial: string;
  fechaFinal: string;
  sma: number;
}

export interface ObjetoSomaEntity {
    tipoIdentificacion: string;
    numeroIdentifiacion: string;
    diagnosticoPrincipal: string;
    diagnosticoRelacionado: string;
    fechaPrestacionServicio: string;
    codigoActividad: string;
    descripcionActividad: string;
    ambitoPrestacion: string;
    formaReconocimiento: string;
    numeroDiasEstancia: string;
    valorActividad: string;
    valorCuotaModeradora: string;
    valorCopago: string;
    tipoCodificacion: string;
    numeroFactura: string;
    periodoDuracion: string;
    fechaSolicitudServicio: string;
    fechaSolicitudMedica: string;
    plan: string;
    peydt: string;
}
